import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ProductionIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.3613 6.95189C12.2061 7.00319 12.0398 7.031 11.8669 7.031C11.6939 7.031 11.5276 7.00319 11.3724 6.95188L8.25024 10.0113C8.49698 10.3725 8.64088 10.8069 8.64088 11.2742C8.64088 11.7569 8.48739 12.2044 8.22565 12.5724L12.8405 18.2251H15.4015V20.0001H5.75661V18.2251H7.56376L5.34726 13.3381C4.55251 12.9774 4.00122 12.1889 4.00122 11.2742C4.00122 10.0187 5.03984 9.00098 6.32105 9.00098C6.44676 9.00098 6.57014 9.01078 6.69044 9.02964L10.3209 5.47204C10.3444 4.65515 11.0276 4 11.8669 4C12.7062 4 13.3893 4.65518 13.4128 5.47209L16.2604 8.2625C16.3405 8.24994 16.4228 8.24341 16.5065 8.24341C17.3607 8.24341 18.0531 8.92192 18.0531 9.75891C18.0531 9.94161 18.0201 10.1168 17.9596 10.279C19.1594 10.7876 19.9988 11.9579 19.9988 13.3203H18.1875C18.1875 12.4713 17.4851 11.783 16.6187 11.783C15.7522 11.783 15.0498 12.4713 15.0498 13.3203H13.2385C13.2385 12.0305 13.9909 10.9129 15.089 10.3658C15.006 10.18 14.96 9.97472 14.96 9.75891C14.96 9.67675 14.9667 9.59612 14.9795 9.5175L12.3613 6.95189Z"
      />
    </SvgIcon>
  );
});
